import React from 'react';
import classNames from 'classnames';
import { CollapsibleSection } from 'components/CollapsibleSection';
import AdjustmentsIcon from 'icons/Adjustments.icon';
import { useTranslation } from 'react-i18next';

import './MemberRoles.styles.scss';

type MemberRolesProps = {
  className?: string;
  defaultOpen?: boolean;
};

const MemberRoles: React.FC<MemberRolesProps> = (props) => {
  const { children, defaultOpen = true, className } = props;

  const classes = classNames('member-roles', 'white-panel', className);

  const { t } = useTranslation();

  return (
    <CollapsibleSection
      className={classes}
      defaultOpen={defaultOpen}
      trigger={
        <div className="member-roles__heading">
          <p className="heading">
            <AdjustmentsIcon />
            {t('editRolesPermissions')}
          </p>
        </div>
      }
    >
      {children}
    </CollapsibleSection>
  );
};

export default MemberRoles;
